import localforage from 'localforage'

export class AccountAssumption {
  static _localForage = localforage.createInstance({
    name: 'accountAssumption',
  })

  static assumedAs = async () => {
    return await this.getItem('assumedUser')
  }

  static assumeInto = async (userId) => {
    return await this.setItem('assumedUser', userId)
  }

  static unassume = async () => {
    return await this.clearAll()
  }

  static getItem = async (key) => {
    try {
      return await this._localForage.getItem(key)
    } catch (e) {
      console.error('Error getting key from localforage:', key, e)
      return null
    }
  }

  static setItem = async (key, value) => {
    try {
      // ✅ Wait for IndexedDB/localforage write to complete
      await this._localForage.setItem(key, value)
      return true
    } catch (e) {
      console.error('There was a problem setting key to local storage', e)
      return false
    }
  }

  static deleteItem = async (key) => {
    try {
      await this._localForage.removeItem(key)
      return true
    } catch (e) {
      console.error('There was a problem deleting key from local storage', e)
      return false
    }
  }

  static clearAll = async () => {
    try {
      await this._localForage.clear()
    } catch (e) {
      console.error('Error clearing localforage store', e)
    }
  }
}
